export enum AuthApprovalStatus {
    Approved = 'approved',
    Consumed = 'consumed',
    Expired = 'expired',
    NotFound = 'not_found',
    Pending = 'pending',
    Rejected = 'rejected',
}
